// Copyright (c) Proto Labs, Inc. All Rights Reserved.
export const TokenManagerEventTypes = {
    AuthenticationChanged: 'tokenManagerAuthenticationChanged',
    ClaimsUpdated: 'tokenManagerClaimsUpdated',
};
//# sourceMappingURL=TokenManagerEventTypes.js.map